import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { EquipmentItem } from './equipment-item';

export class EquipmentPart implements ViewModel, EquipmentItem {
  readonly friendlyTypeNameSingular = 'Equipment Part';
  readonly apiRoute: string = CONFIG.apiRoutes.equipmentPart;
  id: string;
  name: string;
  identifier: string;
  parentEquipmentComponentId: string;

  json() {
    return this;
  }

  public loadFromJson(data) {
    this.id = data.id;
    this.name = data.name;
    this.identifier = data.identifier;
    this.parentEquipmentComponentId = data.parentEquipmentComponentId;
  }
}
